var LeaveTypeStore = {
    leaveTypes: null,
    leaveTypesOrder: null,
    leaveTypesOrdered: null,

    getLeaveTypes: function()
    {
        return this.leaveTypes;
    },

    getLeaveType: function(id)
    {
        return this.leaveTypes[id];
    },

    setLeaveTypes: function(leaveTypes)
    {
        this.leaveTypes = leaveTypes;
    },

    getLeaveTypesOrder: function()
    {
        return this.leaveTypesOrder;
    },

    setLeaveTypesOrder: function(leaveTypesOrder)
    {
        this.leaveTypesOrder = leaveTypesOrder;
    },

    getLeaveTypesOrdered: function()
    {
        return this.leaveTypesOrdered;
    },

    setLeaveTypesOrdered: function(leaveTypesOrdered)
    {
        this.leaveTypesOrdered = leaveTypesOrdered;
    }
};

export default LeaveTypeStore;



// WEBPACK FOOTER //
// ./web/js/store/LeaveTypeStore.js